import { DIRECTION } from "../common/constants";
export const tdStyles = {
	padding: "0 3px 3px 0"
};

export const thStyles = Object.assign({}, tdStyles, {
    fontWeight: "normal",
    textAlign: "left"
});

export const BUY_COLOR = "#00acf0";
export const SELL_COLOR = "#ec6b10";
export const TEXT_COLOR = "#28313E";
export const LIGHT_TEXT_COLOR = "#888";
export const LIGHT_GREY = "rgb(243, 243, 243)";
export const primaryBlue = "rgb(0,120,231)";
export const secondaryBlue = "rgba(0,120,231,0.5)";
export const secondaryButtonStyles = {
    color: "white",
    backgroundColor: secondaryBlue
};

export const triggerStyles = (showDetails) => ({
    color: showDetails ? "#999" : primaryBlue,
    textDecoration: showDetails ? "none" : "underline",
    cursor: "pointer",
    backgroundColor: showDetails ? "rgba(0,0,0,0.05)" : "transparent",
    borderRadius: "4px 4px 0 0",
    margin: "1px 0 0 0",
    display: "inline-block"
});

export const colorForDirection = (direction) => {
    switch (direction) {
        case (DIRECTION.BUY):
            return BUY_COLOR;
        case (DIRECTION.SELL):
            return SELL_COLOR;
        default:
            return TEXT_COLOR;
    }
};



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/styles.js
 **/